import { makeAutoObservable } from 'mobx';
import { ChipId } from '@/types/ids';
import type { IChipEditorModel, IChipModel, IChipStoreModel } from '@/interfaces/models';

export class ChipStoreModel implements IChipStoreModel {
  draftMap = new Map<ChipId, IChipModel>();
  chipMap = new Map<ChipId, IChipModel>();
  chipEditorMap = new Map<ChipId, IChipEditorModel>();

  constructor(
    private readonly chipEditorFactory: (chipModel: IChipModel) => IChipEditorModel,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  addChip(chipModel: IChipModel) {
    this.chipMap.set(chipModel.id, chipModel);
    this.chipEditorMap.set(chipModel.id, this.chipEditorFactory(chipModel));
  }

  addDraft(chip: IChipModel) {
    this.draftMap.set(chip.id, chip);
    this.chipEditorMap.set(chip.id, this.chipEditorFactory(chip));
  }

  getChip(chipId: ChipId) {
    return this.draftMap.get(chipId) ?? this.chipMap.get(chipId);
  }

  getChipEditor(chipId: ChipId) {
    return this.chipEditorMap.get(chipId);
  }

  deleteChip(chipId: ChipId) {
    const chip = this.getChip(chipId);
    chip?.logicCircuit.dispose?.();
    chip?.logicCircuit.circuitModel.connectionModel.dispose();
    chip?.structureCircuit.circuitModel.connectionModel.dispose();
    this.draftMap.delete(chipId);
    this.chipMap.delete(chipId);
    this.chipEditorMap.delete(chipId);
  }

  get chips() {
    return Array.from(this.chipMap.values());
  }

  get chipEditors() {
    return Array.from(this.chipEditorMap.values());
  }
}
